module.exports = __webpack_public_path__ + "static/media/mode.640d6be6.svg";